<template>
  <div id="platformAgentModal" ref="modal" class="modal fade">
    <div class="modal-dialog modal-dialog-top">
      <div class="modal-content rounded-4 overflow-hidden min-w-md-560x">
        <div class="modal-body p-0 overflow-x-hidden">
          <div class="d-flex flex-column">
            <div class="row bg-green-01 mb-2">
              <div class="d-flex justify-content-end pt-2 ms-3 position-absolute">
                <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div
                class="d-flex justify-content-center align-items-center mw-sm-90pct ps-sm-4r py-3"
              >
                <img
                  src="@/assets/images/girl-1.png"
                  alt="image"
                  class="img-fluid"
                  style="max-width: 60px"
                />
                <h6 class="fw-bold text-info mb-0 ms-3 me-3">
                  キャリアカウンセリングを受けてみませんか？
                </h6>
              </div>
            </div>

            <div class="text-start px-3 px-md-4 py-3 color-black-02">
              <div class="px-2">
                <p>
                  「社内SE転職ナビエージェント」をご利用いただくと、弊社エージェントがあなたのご経歴、ご希望条件をもとにマッチした求人をご提案。また、書類の添削、事前面接対策などあなたの転職成功までサポートしていきます。ダイレクトサービスと並行してご利用できますので、ぜひご利用ください。
                </p>
                <p>「社内SE転職ナビ　エージェント」の詳細についてはこちら</p>
                <p>
                  ※「社内SE転職ナビ　エージェント」は、これまでのご経験やご希望内容によっては、残念ながらサービスのご提供ができない場合がございます。あらかじめご了承ください。
                </p>
                <p>ご利用される場合は利用規約をご確認・ご同意の上、利用開始してください。</p>
              </div>
            </div>

            <div class="d-flex justify-content-center pb-5">
              <a
                class="btn btn-primary rounded px-4 py-2 text-white size-13"
                @click="redirectToTeaser"
              >
                エージェントサービスのご紹介
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TEASER_PATH } from '@/constant/routers/path';

const redirectToTeaser = (): void => {
  localStorage.setItem('prePathOfTeaser', `${window.location.pathname}${window.location.search}`);
  window.location.href = TEASER_PATH;
};
</script>
